import * as React from "react";
import "./MethodArrow.scss";
import PropTypes from "prop-types";

const MethodArrow = (props) => {
  const isFirefoxOnMac =
    typeof window !== "undefined" &&
    !(window.mozInnerScreenX == null) &&
    window.navigator.platform.indexOf("Mac") >= 0;

  const arrow =
    props.orientation === "horizontal" ? (
      props.direction === "right" ? (
        <i className="px-arrow-right" />
      ) : (
        <i className="px-arrow-left" />
      )
    ) : (
      <i className="px-arrow-up" />
    );

  const scrollToTop = () => {
    if (props.orientation === "horizontal") {
      if (props.direction === "left") {
        if (isFirefoxOnMac) {
          document.getElementsByClassName(
            "method-outer-wrapper"
          )[0].scrollLeft = 0;
        } else {
          document.getElementsByClassName(
            "method-outer-wrapper"
          )[0].scrollTop = 0;
        }
      }
      return;
    }
    window.scrollTo(0, 0);
  };

  let classes = "method-circle ";
  if (props.className !== undefined) {
    classes += ` ${props.className}`;
  }
  if (props.orientation !== undefined) {
    classes += ` ${props.orientation}`;
  }
  if (props.direction !== undefined) {
    classes += ` ${props.direction}`;
  }

  return (
    <div className={classes} onClick={scrollToTop}>
      {arrow}
    </div>
  );
};

MethodArrow.propTypes = {
  orientation: PropTypes.string,
  direction: PropTypes.string,
  className: PropTypes.string,
};

export default MethodArrow;
